<template>
  <div id="car-row" class="flex column-sm justify-space-evenly">
    <div>
      <h3>Información del vehículo</h3>
      <p>{{ car.brand }} {{ car.model }} {{ car.year }} {{ car.color }} - Placas: {{ car.license_plate }}</p>
    </div>
    <div>
      <h3>Información de pasajes</h3>
      <p>No. de Tag: {{ car.contract_tag }}</p>
      <p>{{ car.status ? 'Activo' : 'Inactivo' }}</p>
      <p>No. Económico: {{ car.economic_number }}</p>
      <p>Serie: {{ car.serial_number }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarRow',
  props: {
    car: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#car-row {
  background-color: $white;
  border-radius: 2rem;
  color: #707070;
  margin-top: 1rem;
  position: relative;
}
</style>
